export default {
  payment: {
    paymentForm: {
      modal: {
        title: "Payment"
      },
      form: {
        abcode: "Personal account",
        fullname: "Full name",
        address: "Residence address",
        dateBegin: "Creation date",
        dateEnd: "Closing date",
        payTab: {
          title: "Payment",
          datePay: "Date of payment",
          dateBank: "Date by bank",
          sumPay: "Payment amount",
          numPayDoc: "Payment document number",
          methodPay: "Payment method",
          orgPay: "Organization",
          accountPay: "Checking account",
          purpPay: "Purpose of payment",
          statusPay: "Payment status",
          datePayFrom: "Payment period from",
          datePayTo: "to",
          sumPayMust: "Obligatory payment",
          dateSaveReadings: "Date of reading",
          counter: "Counter",
          dateReading: "Reading at",
          current: "Current",
          difference: "Difference"
        },
        actTab: {
          title: "Redemption by deed",
          act: "Act",
          actDate: "Date:",
          actSum: "Amount:",
          actType: "Type:",
          note: "Note"
        },
        noteTab: {
          title: "Note"
        }
      },
      abcodeNotFound: "Personal account not found",
      info: {
        add: "Adding an entry",
        edit: "Changing an entry",
        del: "Refund of payment"
      },
      actSwitcher: "F2 - Act",
      buttons: {
        AddReadingOneZone: "Add Reading",
        AddReadingTwoZone: "Add 2-zone counter reading",
        AddReadingThreeZone: "Add 3-zone counter reading",
        DeleteReading: "Delete Reading"
      },
      alert: {
        pointNumberCannotBeEmpty: "The metering point number cannot be empty",
        modifyCurrentRecord: "Modify the current record?",
        makeRefund: "Make a refund?",
        confirmMakeRefund:
          "Are you sure about the refund of this payment to the subscriber?",
        actExistsNoChangeAbcode:
          "An act is attached to this payment, it is impossible to change the personal account"
      }
    },
    searchSubscribersForm: {
      modal: {
        title: "Subscriber Search"
      },
      form: {
        fio: "Full name",
        street: "Street",
        house: "House",
        corpHouse: "House building",
        flat: "Apartment",
        ncount: "Counter number",
        nplomb: "Seal number",
        inn: "INN",
        eic: "EIC",
        abcode: "Personal account",
        abcodeBegin: "Per. account opened",
        abcodeEnd: "closed",
        area: "Area",
        nact: "Act number",
        fioPerson: "Surname individual",
        nbid: "Application number",
        naccount: "Account number",
        ncontract: "Contract number",
        phone: "Phone",
        nHouseAccount: "House counter number"
      },
      extendedSearch: "F2 Advanced Search",
      help: {
        message1:
          '<p>Search terms are divided into two parts: basic and additional. Basic - Full Name, Street, House, Apartment, Counter. Additional (Act number, date of Creation and Closure of the personal account, District) are displayed if you check the "Advanced search" box.</p>',
        message2:
          "<p>The entered values ​​are remembered and automatically appear when the form is called again.</p>",
        message3:
          '<p>The search is carried out by the totality of all the specified features. Additional conditions are considered only if the "Advanced Search" checkbox is selected.</p>',
        message4:
          '<p>The surname, counter number, act number and personal account can be partially indicated by checking the "entry" checkboxes.</p>',
        message5:
          '<p>These fields can also be searched using the mask: the "?" means any single character, the "*" means zero or more characters.</p>',
        message6:
          '<p>(checkboxes are a special case of a mask, setting them is similar to attaching "*" at the beginning and at the end of the entered value).</p>'
      }
    },
    searchResultsForm: {
      modal: {
        title: "Selection Result"
      },
      selectedRows: "Selected Records:"
    }
  }
};
